import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from "@sentry/react";
import { Replay } from "@sentry/replay";
import App from './App.tsx';
import './index.css';
import { disableConsoleInProduction } from './utils/logger';

// Initialize Sentry
Sentry.init({
  dsn: "https://3606db806ef06107dabb1e013cced6d1@o4509286492536832.ingest.de.sentry.io/4509286496927824",
  tracesSampleRate: 0, // disable performance tracing
  sendDefaultPii: false, // don't send IP address (privacy-friendly)
  integrations: [
    new Replay({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  replaysSessionSampleRate: 1.0, // Set to 100% for development/testing
  replaysOnErrorSampleRate: 1.0, // Sample all sessions with errors

  beforeSend(event) {
    if (event.user) {
      event.user.ip_address = undefined;
    }
    return event;
  },
});

// Disable console logging in production (after Sentry initialization)
// This prevents sensitive information from being logged in production
disableConsoleInProduction();

// Note: We keep console methods intact so that Sentry can still capture breadcrumbs.

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<h1>Something went wrong.</h1>}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>
);
